import FilesUploadFields from './FilesUploadFields';

export default FilesUploadFields;
